import React from 'react';
import { Link } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import './SolarHybrid.css';
import { useNavigate } from 'react-router-dom';


// Importing images from assets/Project/Project3
import heroImg from '../../assets/Project/Project3/Image.png';
import image1 from '../../assets/Project/Project3/Image1.png';
import image2 from '../../assets/Project/Project3/Image2.png';
import image3 from '../../assets/Project/Project3/Image3.png';
import image4 from '../../assets/Project/Project3/Image4.png';

// Keep the global references for bottom cards (from respective projects)
import card1Img from '../../assets/Project/image.png'; // Madhubani EPC
import card2Img from '../../assets/Project/image2.png'; // Reusing an image for the second Madhubani EPC reference
import card3Img from '../../assets/Project/image4.png'; // Tamil Nadu
import CustomButton from '../Button/CustomButton';

const SolarHybrid = () => {
      const navigate = useNavigate();

    return (
        <div className="solar-hybrid-page">
            {/* Hero Section */}
            <section className="solar-hybrid-hero">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-6 hero-text-col">
                            <h1 className="hero-title">Solar Hybrid EPC Project – 150 kW</h1>
                            <h3 className="hero-location">Pusa, Samastipur, Bihar</h3>
                            <p className="hero-description">
                                This 150 kW solar hybrid project was developed in Pusa, Samastipur.
                                The system combines solar power generation with energy storage to ensure stable and reliable supply.
                            </p>
                             <CustomButton
                variant="white"
                size="lg"
                text=" Discuss Your Project"
                onClick={() => navigate("/contact")}
              />
                        </div>
                        <div className="col-lg-6 hero-image-col">
                            <img src={heroImg} alt="Solar Hybrid Storage Container" className="hero-img img-fluid" />
                        </div>
                    </div>
                </div>
            </section>

            {/* Main Content Section */}
            <main className="solar-hybrid-content">
                <div className="container">
                    {/* Project Overview */}
                    <section className="content-section">
                        <h2>PROJECT OVERVIEW</h2>
                        <p>
                            This project was designed to provide consistent power even when sunlight is not available.
                            Unlike a regular solar plant, this hybrid system includes a battery storage solution. During the day, solar panels generate electricity. The extra energy is stored and used later when required.
                            The goal was simple — improve reliability and reduce power interruptions.
                        </p>
                    </section>

                    {/* Our Role */}
                    <section className="content-section">
                        <h2>OUR ROLE IN THIS PROJECT</h2>
                        <p>For this hybrid EPC project, our team handled the complete engineering and execution process.</p>
                        <p>Our work included:</p>
                        <ul>
                            <li>Designing the solar + storage system</li>
                            <li>Selecting suitable battery storage solution</li>
                            <li>Procurement of solar modules and equipment</li>
                            <li>Installation of panels and battery container</li>
                            <li>Electrical integration and system testing</li>
                        </ul>
                    </section>

                    {/* Project Highlights */}
                    <section className="content-section">
                        <h2>PROJECT HIGHLIGHTS</h2>
                        <ul>
                            <li>150 kW hybrid solar installation</li>
                            <li>Integrated battery energy storage system</li>
                            <li>Located in Pusa, Samastipur, Bihar</li>
                            <li>Designed for stable and backup-supported power</li>
                        </ul>
                    </section>

                    {/* Execution Approach */}
                    <section className="content-section">
                        <h2>EXECUTION APPROACH</h2>
                        <ul>
                            <li>Solar panels were installed</li>
                            <li>Battery storage container was positioned and connected</li>
                            <li>Inverters and control systems were configured</li>
                        </ul>
                    </section>

                    {/* Impact of the Project */}
                    <section className="content-section child-impact">
                        <h2>IMPACT OF THE PROJECT</h2>
                        <ul>
                            <li>This hybrid project ensures reliable power supply even during low sunlight hours.</li>
                            <li>It reduces dependency on conventional power and improves energy stability for the local area.</li>
                            <li>The integration of storage makes the system more flexible and dependable.</li>
                        </ul>
                    </section>

                    {/* Image Grid */}
                    <section className="image-grid-section">
                        <div className="row image-grid">
                            <div className="col-md-6 grid-item">
                                <img src={image1} alt="Solar Panel Field" className="img-fluid grid-img" />
                            </div>
                            <div className="col-md-6 grid-item">
                                <img src={image2} alt="Battery Storage Containers" className="img-fluid grid-img" />
                            </div>
                            <div className="col-md-6 grid-item mt-4 mt-md-0 pt-md-4">
                                <img src={image3} alt="Engineer pointing at Solar Panels" className="img-fluid grid-img" />
                            </div>
                            <div className="col-md-6 grid-item mt-4 mt-md-0 pt-md-4">
                                <img src={image4} alt="Solar Panels and Battery Storage" className="img-fluid grid-img" />
                            </div>
                        </div>
                    </section>

                    {/* Explore More Projects */}
                    <section className="explore-more-section">
                        <h2 className="explore-title">Explore More Renewable Energy Projects</h2>
                        <div className="row">
                            {/* Card 1 */}
                            <div className="col-md-4 mb-4">
                                <Link to="/projects/solar-epc" className="text-decoration-none">
                                    <div className="project-card">
                                        <img src={card1Img} alt="Solar EPC" className="card-img-top" />
                                        <div className="card-body">
                                            <h5 className="card-title">Solar EPC,<br />Madhubani, Bihar</h5>
                                        </div>
                                    </div>
                                </Link>
                            </div>
                            {/* Card 2 */}
                            <div className="col-md-4 mb-4">
                                <Link to="/projects/solar-epc" className="text-decoration-none">
                                    <div className="project-card">
                                        <img src={card2Img} alt="Solar EPC" className="card-img-top" />
                                        <div className="card-body">
                                            <h5 className="card-title">Solar EPC,<br />Madhubani, Bihar</h5>
                                        </div>
                                    </div>
                                </Link>
                            </div>
                            {/* Card 3 */}
                            <div className="col-md-4 mb-4">
                                <Link to="/projects/solar-bess" className="text-decoration-none">
                                    <div className="project-card">
                                        <img src={card3Img} alt="Solar + BESS EPC" className="card-img-top" />
                                        <div className="card-body">
                                            <h5 className="card-title">Solar + BESS EPC<br />Tamil Nadu</h5>
                                        </div>
                                    </div>
                                </Link>
                            </div>
                        </div>
                    </section>
                </div>
            </main>
        </div>
    );
};

export default SolarHybrid;
